import { CommonUtil } from '@utils/common/common';
import { uniqBy } from 'lodash';

export class RankingGridOption {
  getGridDataLayout(uniqueProperty, gameNames) {
    let result = [];
    uniqueProperty.forEach((property) => {
      let gridElement = { property };
      gameNames.forEach((game) => {
        gridElement[game] = 0;
      });
      result.push(gridElement);
    });
    return result;
  }

  categoryRankings(data: any, selectedProperties: string[] | null) {
    const _data = CommonUtil.getArrayByValidate(data);

    // 고유게임명
    const gameNames = Array.from(new Set(_data.map((x) => x.gameName)));
    // 고유속성명
    let uniqueProperty = Array.from(new Set(_data.map((x) => x.property)));
    // seriesNames
    let seriesNames = uniqBy(
      _data.map((x) => ({ unique: `${x.gameName}_${x.property}`, gameName: x.gameName, property: x.property })),
      'unique'
    );

    // if (!!selectedProperties && selectedProperties.length > 0) {
    //   seriesNames = seriesNames.filter((x) => selectedProperties.includes(x.property));
    //   uniqueProperty = selectedProperties;
    // }

    let gridData = this.getGridDataLayout(uniqueProperty, gameNames);

    seriesNames.forEach((seriesName) => {
      const nowRanking = _data.find((x) => x.gameName === seriesName.gameName && x.property === seriesName.property);
      gridData = gridData.map((item) => {
        if (item.property === seriesName.property) {
          item[seriesName.gameName] = nowRanking?.value || '';
          return item;
        } else {
          return item;
        }
      });
    });
    console.log('gridData: ', gridData);
    return {
      data: gridData,
      columns: [
        {
          name: 'Category',
          selector: (row) => row.property,
          sortable: true,
        },
        ...gameNames.map((gameName) => ({
          key: gameName,
          name: gameName,
          selector: (row) => row[gameName],
          sortable: true,
        })),
      ],
    };
  }
}
